module.exports = __webpack_public_path__ + "img/icon_creation.a6a42b7b.svg";